<template>
    <div>
        <b-sidebar class="d-none d-lg-block" z-index="2" visible no-close-on-route-change no-header-close :title="barTitle" text-variant="rekka-white" bg-variant="rekka-blue">
            <!--<Sidebar-user />-->
            <Sidebar-nav :user="user" :checkRole="checkRole" />
        </b-sidebar>
        <b-sidebar class="d-lg-none" z-index="2" visible no-header-close :title="barTitle" text-variant="rekka-white" bg-variant="rekka-blue" backdrop @hidden="setMobileSidebar">
            <!--<Sidebar-user />-->
            <Sidebar-nav :user="user" :checkRole="checkRole" />
        </b-sidebar>
    </div>
</template>

<script>
import PageOptions from '@/config/PageOptions'
//import SidebarUser from './SidebarUser'
import SidebarNav from './SidebarNav'

export default {
    name: 'Sidebar',
    components: {
        //SidebarUser,
        SidebarNav
    },
    props: [
		'checkRole',
		'user',
	],
    data() {
        return {
            barTitle: "Rekkapesu"
        }
    },
    methods: {
        setMobileSidebar() {
            PageOptions.pageWithMobileSidebar = false;
        }
    }
}
</script>